// removed by extract-text-webpack-plugin
module.exports = {"contact-hero":"contact-hero","contact-hero-background":"contact-hero-background","contact-hero-content":"contact-hero-content","lead":"lead","nf-contact-page":"nf-contact-page","contact-card":"contact-card","card-body":"card-body","contact-intro":"contact-intro","contact-details":"contact-details","contact-person":"contact-person","contact-name":"contact-name","contact-org":"contact-org","contact-info":"contact-info","contact-info-item":"contact-info-item","contact-label":"contact-label","contact-value":"contact-value"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/static/Contact/Contact.scss
// module id = 2711
// module chunks = 1